import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaInfoCircle, FaBriefcase, FaUsers, FaEnvelope } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const BottomNav = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const navItems = [
    { 
      name: t('common.home'), 
      path: '/', 
      icon: FaHome 
    },
    { 
      name: t('common.about'), 
      path: '/about', 
      icon: FaInfoCircle 
    },
    { 
      name: t('common.services'), 
      path: '/services', 
      icon: FaBriefcase,
      highlight: true // Services sebagai menu utama
    },
    { 
      name: t('common.management'), 
      path: '/management', 
      icon: FaUsers 
    },
    { 
      name: t('common.contact'), 
      path: '/contact', 
      icon: FaEnvelope 
    },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-elegant-lg z-50">
      <div className="flex justify-around items-center h-16 px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center min-w-[60px] h-full transition-all duration-300 relative ${
                active 
                  ? 'text-maroon-700' 
                  : 'text-gray-500'
              }`}
            >
              {/* Highlight bubble untuk Services */}
              {item.highlight && active && (
                <div className="absolute -top-8 bg-maroon-700 rounded-full p-3 shadow-lg border-4 border-white">
                  <Icon size={24} className="text-white" />
                </div>
              )}
              
              {/* Icon normal untuk menu lain atau Services tidak aktif */}
              {(!item.highlight || !active) && (
                <Icon 
                  size={active ? 24 : 20} 
                  className={`transition-all duration-300 ${
                    active ? 'animate-bounce-subtle' : ''
                  }`}
                />
              )}
              
              {/* Label */}
              <span 
                className={`text-[10px] mt-1 font-medium transition-all duration-300 ${
                  active ? 'text-maroon-700' : 'text-gray-500'
                } ${item.highlight && active ? 'mt-2' : ''}`}
              >
                {item.name}
              </span>
              
              {/* Active indicator dot */}
              {active && !item.highlight && (
                <span className="absolute bottom-1 w-1 h-1 bg-maroon-700 rounded-full"></span>
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
